import { call, put } from 'redux-saga/effects';
import { sendLog, LoggerStatusEnum } from 'ui-model';

// resuable fetch subroutine
// types : action types object with REQUEST, SUCCESS, ERROR
// fn    : resource function: authResource.signIn | ...
// args  : arguments passed to the resource function
export default function* sagaFetch(types, fn, args = {}) {
  let requestAction;
  try {
    requestAction = { type: types.REQUEST, ...args };
    yield put(requestAction);
    const res = yield call(fn, args);
    yield put({ type: types.SUCCESS, ...res, meta: { requestAction } });
    return res;
  } catch (error) {
    if (args.token && error.response.status === 403 && error.response.statusText === '') {
      sendLog(
        'Error on sagaFetch.js while validating token',
        { errorStack: error, context: { types, fn } },
        LoggerStatusEnum.info,
      );
      yield put({ type: types.ERROR, meta: { ignoreErrors: true } });
      return { error, meta: { requestAction } };
    }
    sendLog('Error on sagaFetch.js', { errorStack: error, context: { types, fn } }, LoggerStatusEnum.error);
    yield put({ type: types.ERROR, error });
    return { error, meta: { requestAction } };
  }
}
